import constants from "../constants/constants";
import Awards from "./awards.component";
import ScrollDownIndicator from "./scrollDownloadIndicator";
import { useUserParams } from "../hooks/useUserParams";

export default function Hero() {
    const {
        getCurrentAgentName,
        getCurrentAgentTitle,
        getCurrentBrokerage,
    } = useUserParams();

    const agentName = getCurrentAgentName();
    const agentTitle = getCurrentAgentTitle();
    const brokerage = getCurrentBrokerage();

    return (
        <div
      className="w-full min-h-[100vh] relative overflow-hidden bg-black"
      style={{
        backgroundImage: `linear-gradient(rgba(63, 63, 97, 0),rgba(10, 10, 30, 0.069)), url(${constants.HOME_IMAGE})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Glass Morphing Content Card */}
      <div className="absolute top-1/2 right-[8%] -translate-y-1/2 bg-white/10 backdrop-blur-md rounded-3xl shadow-2xl p-16 z-10 border border-white/20 max-w-2xl w-[520px] animate-float">
        <h2 className="text-cyan-400 text-lg font-mono tracking-widest mb-2 drop-shadow-neon animate-gradient-x">
          {constants.HERO_SLOGAN}
        </h2>
        <h1 className="text-white text-5xl sm:text-7xl font-extrabold font-mont mb-4 drop-shadow-neon animate-gradient-x">
          {agentName}
        </h1>
        <h4 className="text-cyan-200 text-2xl font-mont mb-4 drop-shadow-neon">
          {agentTitle}, {brokerage}
        </h4>
        <p className="text-white/80 text-lg mb-8 font-light animate-fade-in-slow">
          {constants.HERO_SUBTITLE}
        </p>
        <a
          to={constants.HERO_CTA_LINK}
          className="inline-block px-8 py-3 rounded-full bg-cyan-500 text-black font-bold text-lg shadow-lg hover:bg-cyan-400 hover:shadow-cyan-500/50 transition-all duration-300 neon-glow animate-pulse"
        >
          {constants.HERO_CTA_TEXT}
        </a>
      </div>
    </div>
    );
}
